const siteRoutes = {
  site: 'site',
  containers: {
    home: 'home',
    order: 'order',
    account: 'account',
    list: 'list',
    detail: 'detail',
    coupon: 'coupon',
    coupons: 'coupons',
    deals: 'deals',
    rewardProgramDetails: 'program-details',
    referral: 'referral',
    locations: 'locations',
    location: 'location',
    aboutUs: 'about-us',
    helpSupport: 'help-support',
    vipPassList: 'pass-list',
    vipPassDetail: 'pass-detail',
    vipMembershipList: 'membership-list',
    myRewards: 'my-rewards',
    delivery: 'delivery-address',
    communityOrdering: 'community-ordering',
    workWithUs: 'work-with-us',
    franchiseEnquiry: 'franchise-enquiry',
    deleteAccountSuccess: 'delete-account-success',
    permissionsAndPrivacy: 'permissions-and-privacy',
    bookTable: 'book-table',
    tableBookings: 'table-bookings',
    wallet: 'wallet',
    selectOutlet: 'select-outlet',
  },
};

export default siteRoutes;
